import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { showNotification, Button } from "react-admin";
import { push } from "react-router-redux";
import dataProviderFactory from "../dataProvider";
import { DELETE } from "react-admin";
import { isNil } from "ramda";
import Close from "@material-ui/icons/Close";

class CloseMaintenanceButton extends Component {
  handleClick = async () => {
    const dataProvider = await dataProviderFactory("rest");
    const { push, record, showNotification } = this.props;
    dataProvider(DELETE, "maintenances_due", { id: record.id })
      .then(() => {
        push("/maintenances_due/");
      })
      .catch(e => {
        showNotification("bad_item", "warning");
      });
  };
  render() {
    const { record } = this.props;
    if (isNil(record.date_end)) {
      return (
        <Button
          onClick={this.handleClick}
          style={{ width: "100px" }}
          label="Close"
        >
          <Close />
        </Button>
      );
    }
    return "";
  }
}

CloseMaintenanceButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func
};

export default connect(null, {
  showNotification,
  push
})(CloseMaintenanceButton);



// WEBPACK FOOTER //
// ./src/resources/closeMaintenanceButton.js